import React, { useState } from 'react';

import { Document, Page } from 'react-pdf';
import Button from 'components/atoms/Button';
import Toast from 'components/molecules/Toast';
import { useTranslation } from 'helpers/useTranslation';
import { BtnHolder, PdfHolder, TextHolder } from './PdfViewer.styles';

function PdfViewer({ pdf, onClose = () => {} }) {
  const [totalPages, setNumPages] = useState(null);
  const { t } = useTranslation();
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleDownloadPdf = () => {
    try {
      if (!pdf) {
        Toast({ type: 'error', message: t('No file found') });
        onClose();
        return;
      }
      fetch(pdf) // Fetch the PDF file
        .then(response => response.blob()) // Get the response as a Blob
        .then(blob => {
          const url = window.URL.createObjectURL(new Blob([blob])); // Create a URL for the Blob
          const link = document.createElement('a');
          link.href = url;
          link.download = 'document.pdf'; // Set the download attribute
          link.style.display = 'none'; // Hide the link
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url); // Release the Blob URL
          Toast({ type: 'success', message: t('Pdf downloaded successfully') });
          onClose();
        })
        .catch(error => {
          Toast({ type: 'error', message: error?.message });
        });
    } catch (error) {
      Toast({ type: 'error', message: error?.message });
    }
  };
  return (
    <PdfHolder>
      <TextHolder>
        <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
          {totalPages > 0 &&
            Array(totalPages)
              .fill(null)
              .map((_, i) => i + 1)
              .map(page => (
                <>
                  <Page pageNumber={page} scale={1} />
                  <p
                    css={`
                      text-align: center;
                    `}>
                    Page {page} of {totalPages}
                  </p>
                </>
              ))}
        </Document>
      </TextHolder>
      <BtnHolder>
        <Button
          type="primary"
          sm
          rounded
          width="120"
          onClick={() => {
            // form.setFieldsValue({ readandagree: true });
            handleDownloadPdf();
          }}>
          {t('Download')}
        </Button>
      </BtnHolder>
    </PdfHolder>
  );
}

export default PdfViewer;
